import React, { createContext, useContext, useEffect, useState } from 'react';
import { resolveTheme } from '../constants/themes';
import { getSettings } from '../utils/settingsCache';

const STORAGE_KEY = 'gr-theme-cache';
const ThemeContext = createContext({ theme: resolveTheme({}), setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) return resolveTheme(JSON.parse(cached));
    } catch {}
    return resolveTheme({});
  });

  useEffect(() => {
    getSettings()
      .then(data => {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch {}
        setTheme(resolveTheme(data));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--color-background-secondary', theme.surfaceAlt);
    root.style.setProperty('--color-border-tertiary', theme.border);
    document.body.style.background = theme.background;
    document.body.style.color = theme.text;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext).theme;
export const useSetTheme = () => useContext(ThemeContext).setTheme;
